/**
 * @name FloatingLabelInputGroupBtn
 * @extends HTMLButtonElement
 * @desc Simply applies floating label styles to input group buttons.
 * @author kari
 * @example
 * ```
 * <button is="floating-label-input-group-btn">My Button</button>
 * ```
 */

let InputGroupBtn = Object.create(HTMLButtonElement.prototype);

// eslint-disable-next-line no-use-before-define
InputGroupBtn.attachedCallback = attachedCallback;

export default InputGroupBtn;

/**
 * method definitions
 **************************************************************************/

function attachedCallback() {
    this.classList.add('floating-label-input-group-btn');
}
